import React, { useState } from "react";
import { useAuth } from "../../contexts/authContext";

import { collection, addDoc } from "firebase/firestore";

import { db } from "../../firebase/firebase";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const workCategories = {
    Carpenter: ["Drawer", "Door", "Fixture", "Lock", "Board", "Ply", "Wooden work"],
    CivilWork: ["Plaster", "Floor", "Tiles"],
    Electrical: ["Tube Light", "Track Light", "Socket", "Switch", "Plate", "Wire", "Panel Board", "MCCB", "MCB", "RCB"],
    Glass: ["Façade ACP", "Main Glass", "Trial Room Glass etc"],
    HVAC: ["AC AHU", "Cassette AC", "Split AC", "Ductable AC"],
    Painter: ["Ceiling Damage", "Wall / Ceiling Paint", "MS Railing Paint"],
    "Backup Generators": ["Call to OEM"],
    "Biometric Machines": ["Call to OEM"],
    "CCTV / NVR": ["Call to OEM"],
    "Cleaning Air Units": ["Call to AMC Vendor"],
    "Digital Screens": ["Call to OEM"],
    "EAS / Sensormatic": ["Call to OEM"],
    "Fire Extinguishers": ["Call to OEM"],
    "Intruder Alarm System": ["Call to OEM"],
    "Lifts / Dumb Waiters": ["Call to OEM"],
    "Music Device [Image Sound]": ["Call to OEM"],
    "Music Speaker System": ["Call to OEM"],
    "Note Counting Machine": ["Call to OEM"],
    "Safe Locker": ["Call to OEM"],
    Servo: ["Call to OEM"],
    Signages: ["Call to OEM"],
    "Smoke Alarm": ["Call to OEM"],
    "Steam Press": ["Call to OEM"],
    UPS: ["Call to OEM"]
};

export default function AddTicket({ onBack }) {
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedSubCategory, setSelectedSubCategory] = useState("");
    const [description, setDescription] = useState("");
    const [image, setImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [imageName, setImageName] = useState("");
    const [ticketSubmitted, setTicketSubmitted] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    

    const { userData, userDocId } = useAuth();

    const reverseFormatDateTime = (formattedDate) => {
        if (!formattedDate) return "";
      
        // Split date and time
        const [datePart, timePart] = formattedDate.split(", ");
        const [day, month, year] = datePart.split("/");
        let [hour, minute, second] = timePart.split(":");
      
        return `${day}${month}${year}_${hour}${minute}${second}`;
      };

      function generateTicket() {
        const prefix = "TKT-";
        const date = new Date().toLocaleString("en-GB", { 
            day: "2-digit", month: "2-digit", year: "numeric", 
            hour: "2-digit", minute: "2-digit", second: "2-digit",
            hour12: false 
        }).replace(/[/]/g, "").replace(/[,]/g, "").replace(/\s/, "_").replace(/[:]/g, ""); 
        
        const randomSuffix = Math.floor(Math.random() * (999 - 100 + 1)) + 100; // Random number between 100-999
    
        return `${prefix}${date}${randomSuffix}`;
    }

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
    
        if (file) {
            const maxSize = 1 * 1024 * 1024; // 1MB
            const reader = new FileReader();
    
            reader.readAsDataURL(file);
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");
    
                    // Reduce size to 30% of original
                    canvas.width = img.width * 0.3;
                    canvas.height = img.height * 0.3;
    
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    
                    // Convert to compressed base64
                    canvas.toBlob(
                        (blob) => {
                            if (blob.size > maxSize) {
                                alert("Compressed image is still larger than 1MB. Please upload a smaller image.");
                                return;
                            }
    
                            const compressedReader = new FileReader();
                            compressedReader.readAsDataURL(blob);
                            compressedReader.onloadend = () => {
                                setImage(compressedReader.result.split(",")[1]); // Remove prefix
                                setImageName(file.name);
                            };
                        },
                        "image/jpeg",
                        0.6 // Compression quality (0.6 = 60%)
                    );
                };
            };
        }
    };
    
      

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Form validation
        if (!selectedCategory || !selectedSubCategory || !description) {
            alert("Please fill in all required fields.");
            setLoading(false);
            return;
        }

        // Prepare form data
        const formData = {
            address: userData.organizationAddress,
            location: userData.organizationLocation,
            date: reverseFormatDateTime(new Date().toLocaleString()),
            description: description,
            ticketType: selectedCategory,
            subCategory: selectedSubCategory,
            ticketNumber:generateTicket(),
            userID:userDocId,
            status:"open",
            image: image || null
        };

        console.log("Submitting Ticket Data:", formData);

        try {
            // Simulate API call (Replace this with actual backend request)
            // await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulated delay
            
            await addDoc(collection(db, "tickets"), formData);
            setSnackbar({ open: true, message: "Ticket submitted successfully!", severity: "success" });
        
            // alert("Ticket submitted successfully!");
            setTicketSubmitted(true);
            setSelectedCategory("");
            setSelectedSubCategory("");
            setDescription("");
            setImage(null);
            setImageName("");
        } catch (error) {
            console.error("Error submitting ticket:", error);
            alert("Failed to submit the ticket.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-4">
            <h2 className="text-xl font-semibold mb-4">Add a New Ticket</h2>
            <form className="space-y-4">
                {/* Category Dropdown */}
                <select
                    className="border p-2 w-full"
                    value={selectedCategory}
                    onChange={(e) => {
                        setSelectedCategory(e.target.value);
                        setSelectedSubCategory(""); // Reset subcategory when category changes
                    }}
                >
                    <option value="">Select a Category</option>
                    {Object.keys(workCategories).map((category) => (
                        <option key={category} value={category}>
                            {category}
                        </option>
                    ))}
                </select>

                {/* Subcategory Dropdown */}
                <select
                    className="border p-2 w-full"
                    value={selectedSubCategory}
                    onChange={(e) => setSelectedSubCategory(e.target.value)}
                    disabled={!selectedCategory}
                >
                    <option value="">Select a Subcategory</option>
                    {selectedCategory &&
                        workCategories[selectedCategory].map((subCategory) => (
                            <option key={subCategory} value={subCategory}>
                                {subCategory}
                            </option>
                        ))}
                </select>

                {/* Description */}
                <label className="block">Description</label>
                <textarea
                    placeholder="Add description"
                    className="border p-2 w-full"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />

                {/* Image Upload */}
                <label className="block">Upload Image</label>
                <input type="file" className="hidden" id="uploadImage" onChange={handleImageUpload} />
                <label htmlFor="uploadImage" className="bg-blue-500 text-white px-4 py-2 rounded cursor-pointer mt-1 inline-block">
                    Add Image
                </label>
                {image && <p className="text-sm text-gray-600">{imageName}</p>}

                {/* Asset Location (Read-only) */}
                <label className="block">Asset Location</label>
                <input type="text" value={userData.organizationLocation} className="border p-2 w-full bg-gray-200" readOnly />

                {/* Asset Address (Read-only) */}
                <label className="block">Asset Address</label>
                <input type="text" value={userData.organizationAddress} className="border p-2 w-full bg-gray-200" readOnly />

                {/* Submit Button */}
                {!ticketSubmitted && (
                    <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded w-full" onClick={handleSubmit} disabled={loading}>
                        {loading ? "Submitting..." : "Submit"}
                    </button>
                )}
            </form>
            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: "100%" }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
}
